import axios from 'axios';

const instance = axios.create({
	baseURL: 'https://durex-quiz-11996.firebaseio.com/',
	headers: { 'crossDomain': true },
});

export default instance;


// WEBPACK FOOTER //
// ./src/axios-setup.js